import { api } from './api';

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const listPatients = async ({
    userRoleUuid,
    caregiverRoleUuid,
    disabled
} = {}) =>
    api.get('/patients', {
        headers: {
            ...makeRoleHeaders(userRoleUuid),
            ...(caregiverRoleUuid
                ? { 'CVP-QUERY-CAREGIVER': caregiverRoleUuid }
                : {}),
            ...(typeof disabled === 'boolean'
                ? { 'CVP-QUERY-DISABLED': String(disabled) }
                : {})
        }
    });

export const searchPatients = async ({ userRoleUuid, query, disabled } = {}) =>
    api.post(
        '/patients/search',
        { query },
        {
            headers: {
                ...makeRoleHeaders(userRoleUuid),
                ...(typeof disabled === 'boolean'
                    ? { 'CVP-QUERY-DISABLED': String(disabled) }
                    : {})
            }
        }
    );

export const fetchPatient = async ({ userRoleUuid, patientUuid }) =>
    api.post(
        '/patients/fetch',
        { patient: patientUuid },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );

export const createPatientAdmin = async ({ userRoleUuid, payload }) =>
    api.post('/patients/admin', payload, {
        headers: makeRoleHeaders(userRoleUuid)
    });

export const updatePatientAdmin = async ({ userRoleUuid, payload }) =>
    api.patch('/patients/admin', payload, {
        headers: makeRoleHeaders(userRoleUuid)
    });

export const deletePatientAdmin = async ({ userRoleUuid, patientUuid }) =>
    api.delete('/patients/admin', {
        headers: makeRoleHeaders(userRoleUuid),
        data: { patient: patientUuid }
    });
